var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.12 68.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 72"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M62.46 7.18h8.16v60.06H1.5V7.18h9.34m40.62 0h4.75m-16 0h4.75m-16.5 0h5.13m-16.13 0h4.75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.92,
    cy: 39.09,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 39.09,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.08,
    cy: 39.09,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.66,
    cy: 39.09,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.24,
    cy: 39.09,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.82,
    cy: 39.09,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.92,
    cy: 30.38,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 30.38,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.08,
    cy: 30.38,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.66,
    cy: 30.38,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.24,
    cy: 30.38,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.82,
    cy: 30.38,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.92,
    cy: 47.8,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 47.8,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.08,
    cy: 47.8,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.66,
    cy: 47.8,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.24,
    cy: 47.8,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.82,
    cy: 47.8,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.92,
    cy: 56.52,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 56.52,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.08,
    cy: 56.52,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.66,
    cy: 56.52,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.24,
    cy: 56.52,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.82,
    cy: 56.52,
    r: 2.73,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.98 20.34h27.71"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.6,
    height: 9.96,
    x: 22.79,
    y: 1.5,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    rx: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.6,
    height: 9.96,
    x: 11.43,
    y: 1.5,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    rx: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.6,
    height: 9.96,
    x: 45.52,
    y: 1.5,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    rx: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.6,
    height: 9.96,
    x: 56.88,
    y: 1.5,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    rx: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.6,
    height: 9.96,
    x: 34.16,
    y: 1.5,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    rx: 2.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDates);
export default __webpack_public_path__ + "static/media/dates.9bed4a8169cf7cb387d57f2046ed25e5.svg";
export { ForwardRef as ReactComponent };